"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => `
    <rect y="12" width="104" height="32" rx="16" fill="black" fill-opacity="0.8"/>
    <rect x="24" y="22" width="10" height="12" rx="2" fill="#F4F4F4"/>
    <rect x="70" y="22" width="10" height="12" rx="2" fill="#F4F4F4"/>
`;
//# sourceMappingURL=round-frame-01.js.map